/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import {
	PanelBody,
	SelectControl,
	ToggleControl,
	Button,
} from '@wordpress/components';

import {MediaPlaceholder } from '@wordpress/block-editor';
import {
    useState
} from '@wordpress/element';

import PostTypeSelect from '../../../dynamic-content/dynamicPostTypeSelect.js';
import {VayuBlocksTypography,VayuBlocksAlignment,HeightControl,VayuBlocksBackground} from '@vayu-blocks';
import { SlideButton } from '@vayu-blocks/global';

const HeadingSettingPanel = ({
	        attributes,
            setAttributes,
            context,
			openPanels, 
			onTogglePanel}) => {

    const [colorpanel, setcolorpanel] = useState('color');
	const handelColor = (value) => {
			setcolorpanel(value);
			if (typeof clickBtn === 'function') {
				clickBtn(value);
			}
		}

   return(
    <>
   <PanelBody 
	   title={ __( 'General', 'vayu-blocks' ) }
	   opened={openPanels['vb-heading-general']} onToggle={() => onTogglePanel('vb-heading-general')}
   >
			<VayuBlocksAlignment
				label={ __( 'Align', 'vayu-blocks' ) }
				onChange={(key,value)=>setAttributes({[key]:value})}
				alignment = {{key:'align',value:attributes.align}}
			/>
	         <SlideButton
				button={{ color: "Color", image: "Image" }}
					onChange={(value)=>handelColor(value)}
					defaultValue={'color'}
				/>

	   {colorpanel === 'color' && (

		   <VayuBlocksBackground
				onChange={(key,value)=>setAttributes({[key]:value})}
				colorPanel = {[
							{
								active: ['color'],
								label: 'Color',
								key:'headingColor',
								value:attributes.headingColor
		                    },
							{
								active: ['color'],
								label: 'Hover Color',
								key:'headingHvrColor',
								value:attributes.headingHvrColor
							}
							]}
				/>
	   )}

	   {colorpanel === 'image' && (			
		   <>
			   <h4>{__('Background', 'vayu-blocks')}</h4>
			   {attributes.headingimage ? (
				   <>         
					   <div className="vayu-blocks-image-container">
						   <img src={attributes.headingimage} alt="slideimage" />
						   <button 
							   className="vayu-blocks-change-button" 
							   onClick={() => setAttributes({ headingimage: '' })}
						   >
							   Change
						   </button>
					   </div>
				   </>
			   ) : (
				   <>
					   <MediaPlaceholder
						   icon="format-image"
						   labels={{
							   title: __('Background Image', 'vayu-blocks'),
							   name: __('an image', 'vayu-blocks')
						   }}
						   onSelect={(media) => {
							   setAttributes({
								   headingimage: media.url,
								   headingColor: 'transparent'
							   });
						   }}                                                               
						   accept="image/*"
						   allowedTypes={['image']}
					   />
					   <br/>
				   </>
			   )}
			   
			   <br/>
			   <br/>
			   <ToggleControl
				   label={__('Animate text')}
				   checked={attributes.headinganimation}
				   onChange={(value) => setAttributes({ headinganimation: value })}
			   /> 
			   <Button 
				   style={{ color: 'blue', marginBottom: '20px' }} 
				   onClick={() => setAttributes({ headingimage: '' })}
			   >
				   {__('Clear', 'vayu-blocks')}
			   </Button>
			   
		   </>
		   
	   )}
	   <PostTypeSelect
				   attributes={ attributes }
				   setAttributes={ setAttributes }
				   context={ context }
			   />
       </PanelBody>
	   <PanelBody 
	   title={ __( 'Typography', 'vayu-blocks' ) }
	   opened={openPanels['vb-heading-typo']} onToggle={() => onTogglePanel('vb-heading-typo')}
       >	
	   <VayuBlocksTypography
			value={attributes.typography}
			onChange={(newValues) => {setAttributes({typography:newValues})}}
		/>
		</PanelBody>
      </>
   )
}

export default HeadingSettingPanel;